var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491 415.997L216.314 6.16339e-07L216.314 95.4198L279.037 199.565L310.398 251.637L378.381 296.13L349.393 314.227L467.203 512L491 415.997Z",
    fill: "#8EDDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 415.997L296.686 -2.48503e-05L296.686 95.4198L233.963 199.565L202.602 251.637L134.619 296.13L163.607 314.227L45.7971 512L22 415.997Z",
    fill: "#2697FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.155 331.412L365.739 296.636L259.726 230.324V292.84L310.155 331.412Z",
    fill: "#2697FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.767 331.412L147.183 296.636L253.196 230.324V292.84L202.767 331.412Z",
    fill: "#8EDDE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.048 388.754V317.252L255.973 300.8L232.924 317.252V424.929L328.413 498.22V425.867L280.048 388.754Z",
    fill: "#FF82BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.27100a4a.svg";
export { ForwardRef as ReactComponent };